import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center px-5 py-12" style={{ backgroundColor: '#F7F4EF' }} data-testid="not-found-page">
    <SEO title="Sidan finns inte | Operio" canonical="/404" noindex />
    <div className="max-w-md text-center">
      <div className="w-16 h-16 mx-auto bg-[#E8613A]/10 rounded-2xl flex items-center justify-center">
        <AlertCircle size={32} className="text-[#E8613A]" />
      </div>
      <h1 className="text-3xl font-bold text-[#1A1A1A] mt-6" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
        Sidan hittades inte
      </h1>
      <p className="text-sm text-[#6B6560] mt-3 leading-relaxed">
        Länken du klickade på fungerar inte längre eller pekar på en sida som inte finns.
        Det här kan bero på att vi har gjort en uppdatering — försök igen om en stund.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
        <Link to="/">
          <Button className="bg-[#E8613A] hover:bg-[#D4532F] text-white rounded-full">
            <Home size={14} className="mr-1.5" /> Till startsidan
          </Button>
        </Link>
        <Link to="/kontakt">
          <Button variant="outline" className="rounded-full">
            <ArrowLeft size={14} className="mr-1.5" /> Kontakta oss
          </Button>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
